import { ReactElement } from 'react';
import { Redirect } from 'react-router-dom';
import Permissions from '../../shared/auth/constants/permissions';
import { useHasOneOfPermissions, useHasPermission } from '../Session';
import BasicLayout from '../layouts/BasicLayout';
import HomePage from '../pages/HomePage';

const HomeRoute = (): ReactElement => {
    const canViewMyOffers = useHasPermission(Permissions.SALES_TRANSACTION_VIEW_MY_OFFERS);
    const canViewMyTransactions = useHasOneOfPermissions([Permissions.SALES_TRANSACTION_VIEW_MY_TRANSACTIONS]);

    if (canViewMyOffers) {
        return <Redirect to="/myBids" />;
    }

    if (canViewMyTransactions) {
        return <Redirect to="/salesTransactions" />;
    }

    return (
        <BasicLayout onGrayBackground>
            <HomePage />
        </BasicLayout>
    );
};

export default HomeRoute;
